<template>
  <div class="relative">
    <div v-if="pingAnimation"
      class="animate-ping-notification absolute top-0 left-0 w-full h-full animate-pulse rounded-lg"
      :class="[animationColorClass]"
    />

    <div
      v-if="isVisible"
      class="ds-notification"
      :class="[typeClass, layoutClass, dismissibleClass, additionalClasses]"
    >
      <div class="ds-notification__flex">
        <div
          v-if="icon && !hideIcon"
          class="ds-notification__icon"
        >
          <component
            :is="icon"
            :height="hasBannerLayout ? '24' : '20'"
          />
        </div>
        <div class="ds-notification__body">
          <h4
            v-if="hasBannerLayout"
            class="ds-notification__title"
            :class="[headerAdditionalClasses, { 'ds-notification__title--hidden': !title }]"
          >
            {{ title }}
            <span
              v-if="isDismissible"
              class="ds-notification__dismiss"
              @click="dismiss"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.1248 5.87522L10 10M10 10L5.87521 14.1248M10 10L5.87521 5.87522M10 10L14.1248 14.1248"
                  stroke="#373941"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </h4>
          <slot />
        </div>
      </div>
      <slot name="bottomContent" />
    </div>
  </div>
</template>

<script>
import ExclamationCircleIcon from '@tagvenue/icons/24/bold/alerts-feedback/alert-circle.svg';
import ExclamationTriangleIcon from '@tagvenue/icons/24/bold/alerts-feedback/alert-triangle.svg';
import CheckmarkIcon from '@tagvenue/icons/24/bold/general/check-circle.svg';

import notificationProps from './notificationProps';

export default {
  name: 'BaseNotification',
  mixins: [notificationProps],
  components: { CheckmarkIcon, ExclamationCircleIcon, ExclamationTriangleIcon },
  props: {
    pingAnimation: {
      type: Boolean,
      default: false,
    },
    headerAdditionalClasses: {
      type: String,
      default: '',
    },
    additionalClasses: {
      type: String,
      default: '',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    // @todo MT-665 on Recommender the icon isn't fully displayed
    hasBannerLayout() {
      return this.layout === 'banner';
    },
    animationColorClass() {
      return {
        success: 'bg-green',
        error: 'bg-red',
        warning: 'bg-yellow',
        info: 'bg-blue',
      }[this.type];
    },
    typeClass() {
      return {
        success: 'ds-notification--success',
        error: 'ds-notification--error',
        warning: 'ds-notification--warning',
        info: 'ds-notification--info',
      }[this.type];
    },
    layoutClass() {
      return {
        banner: 'ds-notification--banner',
        inline: 'ds-notification--inline',
      }[this.layout];
    },
    dismissibleClass() {
      return this.isDismissible ? 'ds-notification--dismissible' : '';
    },
    icon() {
      return {
        success: CheckmarkIcon,
        error: ExclamationCircleIcon,
        warning: ExclamationTriangleIcon,
        info: '',
      }[this.type];
    },
  },
  methods: {
    dismiss() {
      this.isVisible = false;
      this.$emit('dismiss');
    },
  },
};
</script>

<style scoped>
.animate-ping-notification {
  animation: notification-ping 1.25s linear infinite;
}

@keyframes notification-ping {
  0% {
    transform: scale(1);
    opacity: 0.50;
  }
  100% {
    transform: scale(1.12);
    opacity: 0;
  }
}
</style>
